import { getPageImage } from "@/lib/page-imagery";
const isoPhoto = getPageImage("/", "iso-choice");
const registrationPhoto = getPageImage("/", "registration-choice");
import { LangLink } from "./LangLink";
import { useLanguage } from "@/lib/language";
export function IsoCertifications() {
  const { t } = useLanguage();
  return (
    <section aria-labelledby="iso-heading" className="ic-section ic-premium-home">
      <div className="ic-section-heading">
        <p className="ic-eyebrow">{t({ en: "Two ways to start", ar: "مساران للبدء" })}</p>
        <h2 id="iso-heading">
          {t({ en: "Choose the work you need.", ar: "اختر الدعم الذي تحتاجه." })}
        </h2>
      </div>
      <div className="ic-service-grid ic-two-columns">
        <LangLink
          to="/services"
          className="ic-service-card ic-home-choice"
          data-service-route="iso"
        >
          <picture className="ic-home-service-photo ic-home-service-picture">
            <source
              media="(min-width: 768px)"
              srcSet={isoPhoto.desktop!.src}
              width={isoPhoto.desktop!.width}
              height={isoPhoto.desktop!.height}
            />
            <img
              src={isoPhoto.mobile!.src}
              width={isoPhoto.mobile!.width}
              height={isoPhoto.mobile!.height}
              loading="lazy"
              decoding="async"
              style={{ objectPosition: isoPhoto.objectPosition }}
              alt={t(isoPhoto.alt)}
            />
          </picture>
          <div className="ic-home-choice-copy">
            <span className="ic-group-number" aria-hidden="true">
              01
            </span>
            <h3>{t({ en: "ISO preparation", ar: "التحضير للأيزو" })}</h3>
            <p>
              {t({
                en: "Prepare a management system for your activities and the standard you need.",
                ar: "جهّز نظام إدارة يناسب أنشطتك والمواصفة التي تحتاجها.",
              })}
            </p>
            <span className="ic-text-link">
              {t({ en: "Explore ISO services", ar: "تعرّف على خدمات الأيزو" })}
            </span>
          </div>
        </LangLink>
        <LangLink
          to="/services/oil-gas-registration"
          className="ic-service-card ic-home-choice"
          data-service-route="registration"
        >
          <picture className="ic-home-service-photo ic-home-service-picture">
            <source
              media="(min-width: 768px)"
              srcSet={registrationPhoto.desktop!.src}
              width={registrationPhoto.desktop!.width}
              height={registrationPhoto.desktop!.height}
            />
            <img
              src={registrationPhoto.mobile!.src}
              width={registrationPhoto.mobile!.width}
              height={registrationPhoto.mobile!.height}
              loading="lazy"
              decoding="async"
              style={{ objectPosition: registrationPhoto.objectPosition }}
              alt={t(registrationPhoto.alt)}
            />
          </picture>
          <div className="ic-home-choice-copy">
            <span className="ic-group-number" aria-hidden="true">
              02
            </span>
            <h3>{t({ en: "Supplier registration", ar: "تسجيل الموردين" })}</h3>
            <p>
              {t({
                en: "Prepare your company file for the buyer and supplier category you are targeting.",
                ar: "جهّز ملف شركتك للجهة المشترية وفئة التوريد المستهدفتين.",
              })}
            </p>
            <span className="ic-text-link">
              {t({ en: "Explore registration services", ar: "تعرّف على خدمات التسجيل" })}
            </span>
          </div>
        </LangLink>
      </div>
      <p className="ic-imagery-note">
        {t({ en: "Illustrative work scenes.", ar: "صور توضيحية لطبيعة العمل." })}
      </p>
    </section>
  );
}
